// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9a30eb1c","453":"ec430d55"}[chunkId] + ".chunk.js";
};